export const getCommissionAsProduct = ({ title, centAmount, currency }) => ({
  title,
  totalPrice: {
    centAmount,
    fractionDigits: 0,
    currencyCode: currency,
  },
  unitPrice: {
    centAmount,
    fractionDigits: 0,
    currencyCode: currency,
  },
});
